class NewDeferredMedia extends HTMLElement {
	constructor() {
		super()
		console.log(
			'NewDeferredMedia',
			this,
			this.querySelector('[id^="Deferred-Poster-"]')
		)
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this)
		)
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(
				this.querySelector('template').content.firstElementChild.cloneNode(true)
			)
			const newElement = document.createElement('div')
			newElement.className = 'new-video-popup'
			document.body.appendChild(newElement)
			document.body.style.overflow = 'hidden'

			this.setAttribute('loaded', true)
			// console.log(this.parentNode,"nihao")
			// window.pauseAllMedia();
			this.parentNode.classList.add('deferred-media-wrapper')
			this.classList.add('newx')
			newElement.appendChild(content.querySelector('.template-wrapper'))

			const closeHandle = function () {
				document.body.style.overflow = 'auto'
				const demos = document.querySelector(
					'.deferred-media-wrapper .deferred-media'
				)
				demos.removeAttribute('loaded')
				document.body.removeChild(newElement)
			}
			var close_video = document.querySelector('.close-video')
			close_video.onclick = closeHandle

			var mask = document.querySelector('.new-video-popup')
			mask.addEventListener('click', closeHandle)
		}
	}
}

customElements.define('new-deferred-media', NewDeferredMedia)
